import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=2f924e66&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Auth.vue"
export default component.exports